<div ngModelGroup="comboObjetivoAtividade-{{data}}" fxFlex="100" fxLayoutGap="20px" fxFlexOffset="20px">
    <combo-pesquisavel #comboObjetivo
                       nome="objetivo-{{data}}"
                       [itens]="dados"
                       itemDescricao="descricao"
                       itemId="id"
                       [showDisplayId]="showDisplayId"
                       [obrigatorio]="obrigatorio"
                       [desabilitado]="desabilitado"
                       placeholder="Nome do objetivo"
                       label="Objetivo"
                       [(valor)]="selecionado"
                       (valorChange)="onValorChange($event)"
                       [itemId]="'idObjetivo'">
    </combo-pesquisavel>
</div>
